import { UserTypes } from "../actions/user";
import { storeState, clearState } from "../utilities/LocalStorage";

const { AUTH_STORE_LOGIN_STATE, AUTH_CLEAR_STORED_LOGIN_STATE } = UserTypes;

const authSelector = state => state.user.payload;

const LoginPersistMiddleware = store => next => action => {
  if (action.type === AUTH_STORE_LOGIN_STATE) {
    storeState(authSelector(store.getState()));
  }

  if (action.type === AUTH_CLEAR_STORED_LOGIN_STATE) {
    clearState();
  }

  next(action);
};

export default LoginPersistMiddleware;



// WEBPACK FOOTER //
// ./src/middlewares/loginPersists.js